import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Layout, Typography, Button, Table, Dropdown, Tag, Upload, Image, Badge, Spin, Empty, Space, message, Progress, Card, Divider, Modal, Radio, Select, Menu, Pagination, Avatar, Drawer, Tabs } from "antd";
import { UserOutlined, PlusCircleFilled, MinusCircleFilled, DownOutlined, PlusOutlined } from '@ant-design/icons'
import { useMutation, useQuery } from "react-query";
import DataView from "./dataView";
import './styles.css'
import { addProduct } from "./api";
import { utilities } from "../../utilities/utlities";
import { productList } from '../../configurations/pmiProductConfig'
import { productsConfig } from '../../configurations/products'
import ProductOverview from "./ProductOverview";
import UploadMedia from "./uploadMedia";
import { UploadOutlined, SyncOutlined, PaperClipOutlined, EllipsisOutlined, RightOutlined, LeftOutlined, ArrowLeftOutlined, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
const AddToProduct = (props) => {
    const [user] = useState(utilities.loggedUser())
    var productsData = []
    const [product, setProduct] = useState('Registered')
    const [productType, setProductType] = useState('pharmacutical')
    const [openDrawer, setOpenDrawer] = useState(false)
    const [fileName, setFileName] = useState('')
    const [fileType, setFileType] = useState('.pdf')
    const [fileData, setFileData] = useState([])
    const [fetchdata, setfetchData] = useState([])
    const [pdfdata, setpdfdata] = useState({})
    const [constantUploadedFile, setUploadedFile] = useState()
    const [productEdit, setProductAdd] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState()
    const [activeTab, setActiveTab] = useState('media')
    const [uploadProductData, setStatusTable] = useState([])
    const [currentIndex, setIndex] = useState()
    const productInfo = {}
    const [statusModel, setStatusModal] = useState(false)
    const productCategory = ['pharmacutical', 'cosmatics']
    const [unregisterProduct, setUnregisterProduct] = useState(fileData?.filter(item => item?.productCategoty == 'Unregistered'))
    const [registerProduct, setRegisterProduct] = useState(fileData?.filter(item => item?.productCategoty == 'Registered'))
  
    const uploadPhotoMutation = useMutation(async (data) => {
        const response = await addProduct.EditProduct(data)
        return response
    }, {
        onSuccess: (data) => {
            if (data != undefined) {
                setSelectedProduct({ ...data?.data?.product?.productDetails, productId: data?.data?.product?._id, CountryOfOrigin: data?.data?.product?.productDetails?.marketAuthorizationHolder?.countryOfOrigin ||data?.data?.product?.productDetails?.marketAuthorizationHolder?.name?.split('[')?.[1] ,Manufacturer: data?.data?.product?.productDetails?.manufacturer?.name })
                const id = data?.data?.product?._id
                const updateddata = fileData?.map(item => {
                    console.log(data?.data?.product?.productDetails)
                    if (item?.productId == id) {
                        return { ...data?.data?.product?.productDetails, productId: data?.data?.product?._id,CountryOfOrigin: data?.data?.product?.productDetails?.marketAuthorizationHolder?.countryOfOrigin ||data?.data?.product?.productDetails?.marketAuthorizationHolder?.name?.split('[')?.[1], }
                    } else {
                        return item
                    }
                })
                setFileData(updateddata)
                message.success("Your Product Update successfully", 3)
            } else {
                message.error("Some thing went wrong")
            }
        }
        , onError: (err) => {
            message.error("Sorry went wrong,Please try again")

        }
    })
    const editproductdata = () => {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: loggedUser.jwtToken,
            }
        }
        uploadPhotoMutation.mutateAsync({ config: config, data: { ...selectedProduct, type: 'text', productId: selectedProduct?.productId } })
    }

    const addProductInfo = (key, value) => {
        productInfo[key] = value
        setSelectedProduct({
            ...selectedProduct,
            [key]: value
        })
    }

    const numberOFpicture = (data, picNumber) => {
        const formData = new FormData();
        formData.append("document", data);
        formData.append('productId', selectedProduct?.productId)
        formData.append('imageNumber', picNumber)
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                Authorization: loggedUser.jwtToken,
            }
        }
        uploadPhotoMutation.mutateAsync({ config: config, data: formData })
    }

    useEffect(() => {
        if (fileData?.length == 0) {
            refetch()
        }
    }, [])

    const cancelEditMode = (value) => {
        setProductAdd(value)
    }

    const setProductDetail = (index) => {
        setSelectedProduct(fileData[index])
        setIndex(index)


    }

    const onSelectProduct = (id) => {
        const index = fileData?.findIndex(item => item?.productId == id)
        setIndex(index)
        const currentProduct = fileData?.find(item => item?.productId == id)
        setSelectedProduct(currentProduct)
        cancelEditMode(true)
    }
    const { refetch, isLoading } = useQuery('productData', () => {
        const response = addProduct.getProduct(user?.jwtToken)
        return response
    }, {
        enabled: false,
        onSuccess: (data) => {
            const finaldata = data?.data?.data?.map((item, index) => {
                console.log(item)
                return { ...item?.productDetails, Supplier: item?.productDetails?.marketAuthorizationHolder?.name, Manufacturer: item?.productDetails?.manufacturer?.name, score: index * 30, status: 'Registered', CountryOfOrigin: item?.productDetails?.marketAuthorizationHolder?.countryOfOrigin || item?.productDetails?.manufacturer?.name?.split('[')?.[1], brand: item?.productDetails?.brand, productId: item?._id }
            })
            setFileData([...finaldata, ...fileData])
            setUnregisterProduct([...finaldata, ...fileData]?.filter(item => item?.productCategoty == 'Unregistered'))
            setRegisterProduct([...finaldata, ...fileData]?.filter(item => item?.productCategoty == 'Registered'))

        }

    })
    const mutation = useMutation(async (data) => {
        if (productType == "pharmacutical") {
            if (data?.type == 'xlsx') {
                const response = await addProduct.fetchExceldata(data)
                return { ...response, productType: productType,type: fileType }
            }
            else {
                const response = await addProduct.AddProduct(data)
                return { data: response, type: fileType }
            }
        }
        else {
            if (data?.type == 'xlsx') {
                const response = await addProduct.fetchExceldata(data)
                return { ...response, productType: productType,type: fileType }
            }
            else {
                const response = await addProduct.fetchProduct(data)
                return { ...response, productType: productType }
            }
        }
    }, {
        onSuccess: (data) => {
            message.success("Your product successfully Fetched", 3)
            console.log(data)
            if (data?.productType == "cosmatics") {
                if (data?.data?.type == "pdf") {
                    var response = {}
                    console.log(data?.data)
                    response['tradeName'] = data?.data?.data?.Name
                    response['strengthPerUnit'] = data?.data?.data?.['Size / Weight / Volume:']
                    response['manufacturer'] = {
                        name: data?.data?.data?.['Company Name:'],
                        countryOfOrigin: data?.data?.data?.['Country of Origin:'],
                    }
                    setpdfdata(response)

                }
                else {
                    const finaldata = data?.data?.map((item, index) => {
                        return {
                            ...item,
                            tradeName: item?.TradeName,
                            strengthPerUnit: item?.Strength,
                            packSize: item?.PackSize,
                            Intredient: item?.Ingredient,
                            dosageForm: item?.Form,
                            Supplier: item?.Supplier, Manufacturer: item?.Manufacturer, score: index * 30, status: product, CountryOfOrigin: item?.CountryOfOrigin, brand: 'UAE', productId: item?.productId,
                        }
                    })
                    setfetchData(finaldata)
                }
            }
            else {
                console.log(data?.type)
                if (data?.type == '.csv' || data.type == '.xlsx') {
                    const finaldata = data?.data?.data?.map((item, index) => {
                        return {
                            ...item,
                            tradeName: item?.TradeName,
                            strengthPerUnit: item?.Strength,
                            packSize: item?.PackSize,
                            Intredient: item?.Ingredient,
                            dosageForm: item?.Form,
                            Supplier: item?.Supplier, Manufacturer: item?.Manufacturer, score: index * 30, status: product, CountryOfOrigin: item?.CountryOfOrigin, brand: 'UAE', productId: item?.productId,
                        }
                    })
                    console.log(finaldata)
                    setfetchData(finaldata)
                }
                else {

                    setpdfdata(data?.data?.data)
                }
            }
        }
    })
    const addProductMutation = useMutation(async (data) => {
        console.log(data)
        const response = await addProduct.saveProduct({ ...data, type: fileType })
        return { data: response, type: fileType }
    }, {
        onSuccess: (data) => {
            console.log(data)
            if (data?.data?.data?.success == true) {
                message.success("Your product successfully Added", 3)
                if (fileType == '.csv') {
                    console.log(data?.data?.data?.data)
                    openDrawerDialog(false)
                    let finaldata = data?.data?.data?.data.map((item, index) => {
                        return { ...item?.product, Supplier: item?.product?.companymarketAuthorizationHolder?.name, Manufacturer: item?.product?.manufacturer?.name, score: index * 30, status: 'Registered', CountryOfOrigin: item?.product?.marketAuthorizationHolder?.countryOfOrigin, brand: item?.product?.brand, productId: item?.product._id, already: item?.product?.already }
                    })
                    finaldata = finaldata?.filter(item => item?.already != true)
                    console.log(finaldata)
                    setFileData([...finaldata, ...fileData])
                    setUnregisterProduct([...finaldata, ...fileData]?.filter(item => item?.product?.productCategoty == 'Unregistered'))
                    setRegisterProduct([...finaldata, ...fileData]?.filter(item => item?.product?.productCategoty == 'Registered'))
                    const stustusTable = data?.data?.data?.data.map((item, index) => {
                        if (item?.product?.already) {
                            return {
                                productName: item?.product?.tradeName || item?.product?.productDetails?.tradeName,
                                status: true,
                                message: 'Product is already exist with this tradeName'
                            }
                        }

                        else {
                            return {
                                productName: item?.product?.tradeName || item?.product?.productDetails?.tradeName,
                                status: false,
                                message: 'Success'
                            }
                        }
                    })
                    setStatusTable(stustusTable)
                    setStatusModal(true)
                }
                else {
                    let finaldata = data?.data?.data?.data.map((item, index) => {
                        return { ...item?.product, Supplier: item?.product?.marketAuthorizationHolder?.name, Manufacturer: item?.product?.manufacturer?.name, score: index * 30, status: 'Registered', CountryOfOrigin: item?.product?.marketAuthorizationHolder?.countryOfOrigin, brand: item?.product?.brand, productId: item?._id, already: item?.product?.already }
                    })
                    finaldata = finaldata?.filter(item => item?.already != true)
                    setFileData([...finaldata, ...fileData])
                    setUnregisterProduct([...finaldata, ...fileData]?.filter(item => item?.product?.productCategoty == 'Unregistered'))
                    setRegisterProduct([...finaldata, ...fileData]?.filter(item => item?.product?.productCategoty == 'Registered'))
                    const stustusTable = data?.data?.data?.data.map((item, index) => {
                        if (item?.product?.already) {
                            return {
                                productName: item?.product?.tradeName || item?.product?.productDetails?.tradeName,
                                status: true,
                                message: 'Product is already exist with this tradeName'
                            }
                        }

                        else {
                            return {
                                productName: item?.product?.tradeName || item?.product?.productDetails?.tradeName,
                                status: false,
                                message: 'Success'
                            }
                        }
                    })
                    setStatusTable(stustusTable)
                    setStatusModal(true)
                    openDrawerDialog(false)
                }
            }
            else {
                message.error(data?.data?.response?.data?.message, 3)
            }

        },
        onError: (error) => {
            message.error("Something Went Wrong", 3)
        }
    })
    const onSaveProduct = () => {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                Authorization: loggedUser.jwtToken,
            }
        }

        if (fileType == '.csv' || fileType == '.xlsx') {

            addProductMutation.mutateAsync({ config: config, productList: fetchdata, productCategoty: product, productType: productType })
        }
        else {
            addProductMutation.mutateAsync({ config: config, pdfData: pdfdata, productCategoty: product, productType: productType })
        }

    }
    const onMenuChange = (value) => {
        if (productCategory?.includes(value)) {
            setProductType(value)
        }
        else {
            setFileType(`.${value}`)
        }
    }
    const openDrawerDialog = (value) => {
        setOpenDrawer(value)
    }
    const fetchProduct = () => {
        if (productType == "pharmacutical") {
            const formData = new FormData();
            formData.append("document", constantUploadedFile);
            formData.append('type', fileType?.replace('.', ''));
            const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                    Authorization: loggedUser.jwtToken,
                }
            }
            mutation.mutateAsync({ config: config, data: formData, type: fileType?.replace('.', '') })
        }
        else {
            const formData = new FormData();
            formData.append("document", constantUploadedFile);
            formData.append('type', fileType?.replace('.', ''));
            const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                    Authorization: loggedUser.jwtToken,
                }
            }
            mutation.mutateAsync({ config: config, data: formData, type: fileType?.replace('.', '') })
        }

    }
    const menu = (
        <Menu>
            <Menu.Item>
                <a target="_blank" rel="noopener noreferrer" onClick={(e) => {
                    e.preventDefault()
                    openDrawerDialog(true)
                    setProduct('Registered')
                }}>
                    Registered
                </a>
            </Menu.Item>
            <Menu.Item>
                <a target="_blank" rel="noopener noreferrer" onClick={(e) => {
                    e.preventDefault()
                    openDrawerDialog(true)
                    setProduct('Unregistered')
                }}>
                    Unregistered
                </a>
            </Menu.Item>
        </Menu>
    );
    const nextProduct = () => {
        if (currentIndex <= fileData?.length - 1) {
            let number = currentIndex
            setProductDetail(number + 1)

        }
    }
    const previousProduct = () => {
        if (currentIndex >= 0) {
            let number = currentIndex
            setProductDetail(number - 1)

        }
    }
    const statusTable = [{
        title: 'Product Name',
        dataIndex: 'productName'
    },
    {
        title: 'Message',
        dataIndex: 'message'
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: (data, row) => {
            if (row?.status == false) {
                return <CheckCircleFilled className=" cross" />
            }
            else {
                return <CloseCircleFilled className="checked" />
            }
        }
    }
    ]

    const statusTabledata = [{
        productName: 'Panadol 10mg',
        message: 'Product is already exist with this tradeName',
        status: true,
    },
    {
        productName: 'Panadol 100mg',
        message: 'Success',
        status: false,
    }
    ]
    const dataTable = [
        {
            title: 'Score',
            dataIndex: 'score',
            render: (row, data) => {
                return <Progress type="circle" percent={(data?.score / 100) * 100} width={50} />
            }
        },
        {
            title: 'Picture',
            dataIndex: 'picture',
            render: (data, row) => {
                if (row?.pic1 != undefined) {
                    return <Image
                        width={50}
                        src={row?.pic1}
                    />
                }
                else {
                    return <Image
                        width={50}
                        src="./image.png"
                    />
                }

            }
        },
        {
            title: 'Product Id',
            dataIndex: 'productId',
        },

        ...productsConfig?.fields?.map(item => {
            return {
                title: item?.title,
                dataIndex: item?.name
            }
        }),

        {
            title: 'Action',
            fixed: 'right',
            dataIndex: 'action',
            render: (row, data) => {
                return <Dropdown trigger={['click']}
                    overlay={<Menu>
                        <Menu.Item key="0" onClick={() => {

                        }}>
                            <a onClick={() => {
                                onSelectProduct(data?.productId)
                            }}>Edit</a>
                        </Menu.Item>
                        <Menu.Divider />
                        <Menu.Item key="1">
                            Delete
                        </Menu.Item>

                    </Menu>}>
                    <EllipsisOutlined />
                </Dropdown>
            }
        }
    ]
    const selectProduct = user?.type == "supplier" ? <Dropdown className="addProductDropDown" overlay={menu} placement="bottomCenter" trigger={['click']}>
        <Button type="primary">Add Product <DownOutlined /></Button>
    </Dropdown> : <Button className="addProductDropDown" type="primary" onClick={() => {
        openDrawerDialog(true)
    }}>Add Product <PlusOutlined /></Button>

    const { Text, Link: TextLink, Title } = Typography
    const { Content } = Layout
    const { Option } = Select
    const { TabPane } = Tabs;
    const fileUpload = (value) => {
        setFileName(value?.file?.name)
        const { onSuccess, onError, file, onProgress } = value
        setUploadedFile(value?.file)
        onSuccess("ok");

    }
    return (

        <Layout className={`layout-pim ${isLoading ? 'product-view-table' : ''}`}>
            <Modal title="Add Product Status" visible={statusModel} onOk={() => {
                setStatusModal(false)

            }} onCancel={() => {
                setStatusModal(false)
            }}>
                <Table columns={statusTable} dataSource={uploadProductData} scroll={{ x: 'max-content' }}></Table>
            </Modal>
            {isLoading ? <Spin size="large" /> :
                !productEdit ?
                    <>
                        <Drawer
                            title={`Add ${product} Product(s)`}
                            placement="right"
                            className="csvData"
                            size={'large'}
                            onClose={() => { openDrawerDialog(false) }}
                            visible={openDrawer}
                            extra={
                                <Space>
                                    <Button onClick={() => {
                                        openDrawerDialog(false)
                                    }}>Cancel</Button>
                                    {fetchdata?.length > 0 || Object.keys(pdfdata)?.length > 0 ? <Button type="primary" className="reg-btn" onClick={() => {
                                        onSaveProduct()
                                        // openDrawerDialog(false)
                                    }}>
                                        Import to Catalog
                                    </Button> : null}
                                </Space>
                            }
                        >
                            <div className="pmi-products-fields-list">{
                                productList?.fields?.map(item => {
                                    if (item?.type == "select") {
                                        return <div className="pmi-single-field">
                                            <span><Text type="danger">*</Text><Text>{item?.title}</Text></span>
                                            <Select defaultValue={item?.options?.[0]?.label} style={{ width: 180 }} onChange={(e) => {
                                                onMenuChange(e)
                                            }
                                            }>
                                                {
                                                    item?.options?.map(item => {
                                                        return <Option value={item?.value}>{item?.label}</Option>

                                                    })
                                                }
                                            </Select>
                                        </div>
                                    }
                                    else if (item?.type == "upload") {
                                        return <div className="pmi-single-field">
                                            <span><Text type="danger">*</Text><Text>{item?.title}</Text></span>
                                            <Upload
                                                accept={fileType}
                                                customRequest={(file) => {
                                                    fileUpload(file);
                                                }}>
                                                <Button icon={fileName == '' ? <UploadOutlined /> : <PaperClipOutlined />}>{fileName != '' ? fileName : item?.secondTile}</Button>
                                            </Upload>
                                        </div>
                                    }
                                    else {
                                        return <div className="pmi-single-field"><Button loading={mutation?.isLoading} type="primary" onClick={() => {
                                            console.log(constantUploadedFile)
                                            if(constantUploadedFile != undefined){
                                            fetchProduct()
                                            }
                                            else{message.warning("Please Upload a file",3)}
                                        }}>{mutation?.isLoading ? null : <SyncOutlined></SyncOutlined>} Fetch</Button></div>
                                    }
                                    //    return <span><Text type="danger">*</Text><Text>{item?.title}</Text></span>
                                })}
                            </div>
                            {fileData?.length > 0 ? <Table className="csvFileData" scroll={{ x: 'max-content' }} columns={dataTable} dataSource={fetchdata} pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5'] }} /> : null}

                        </Drawer>
                        <Content style={{ justifyContent: 'flex-start', marginTop: 25 }} className="site-layout-content">
                            <div className="pim-solution-title">
                                <div className="header-section1">
                                    <Title level={4} className="pimheader">Product Catalog</Title>
                                    <Text type="secondary">{fileData?.length} Products</Text>
                                </div>
                                <div className="action-section">
                                    {selectProduct}
                                </div>
                            </div>
                            {user?.type == "supplier" ? <Tabs className="pim-solution-tab" onChange={() => { }} type="card">
                                <TabPane tab={`All Product (${fileData?.length})`} key="1">
                                    {/* columns={dataTable} dataSource={fileData} */}
                                    <DataView data={fileData} columns={dataTable}   >
                                        {selectProduct}</DataView>

                                </TabPane>
                                <TabPane tab={`Registered (${registerProduct?.length})`}  key="2" selectProduct={selectProduct}>
                                    <DataView columns={dataTable} data={registerProduct} >{selectProduct}</DataView>
                                </TabPane>
                                <TabPane tab={`Unregistered (${unregisterProduct?.length})`} key="3">
                                    <DataView data={unregisterProduct} columns={dataTable}  >{selectProduct}</DataView>
                                </TabPane>
                            </Tabs> : <DataView data={fileData} columns={dataTable}   >
                                {selectProduct}</DataView>}
                        </Content>
                    </> : <div className="detailSection">
                        <div className="title-section">
                            <div className="left-section">
                                <ArrowLeftOutlined className="back-btn" onClick={() => {
                                    cancelEditMode(false)
                                }} />
                                <Title level={4} className="product-title">{`${selectedProduct?.tradeName} - ${selectedProduct?.strengthPerUnit}`}</Title>
                                <Progress type="circle" percent={(selectedProduct?.score / 100) * 100} width={40} />
                            </div>
                            <div className="right-section">
                                {currentIndex == 0 ? null : <Button onClick={() => {
                                    previousProduct()
                                }}><LeftOutlined /></Button>}
                                {currentIndex == fileData?.length - 1 ? null : <Button onClick={() => {
                                    nextProduct()
                                }}><RightOutlined /></Button>}
                            </div>

                        </div>

                        <div className="detail-section">
                            <Menu onClick={(e) => {
                                setActiveTab(e?.key)

                            }} selectedKeys={[activeTab]}
                                mode="horizontal">
                                <Menu.Item key="overview">
                                    Overview
                                </Menu.Item>
                                <Menu.Item key="media">
                                    Media
                                </Menu.Item>
                            </Menu>
                            {activeTab == "media" ? <UploadMedia uploadPhotoMutation={uploadPhotoMutation} selectedProduct={selectedProduct} numberOFpicture={numberOFpicture} /> : null}
                            {activeTab == "overview" ?
                                <ProductOverview productsConfig={productsConfig} addProductInfo={addProductInfo} editproductdata={editproductdata} selectedProduct={selectedProduct} />
                                : null}
                        </div>

                    </div>
            }
        </Layout>
    )
}
export default AddToProduct